import { ResourceDetail } from '../../../../types/resource.types';
import { ResolveFn } from '@angular/router';
import { of } from 'rxjs';
import { inject } from '@angular/core';
import { ResourceApiService } from '../../../../services/resource-api.service';

export const resourceResolver: ResolveFn<ResourceDetail | null> = (route) => {
  if ('create' === route.routeConfig?.path) {
    return of(null);
  }
  // The form needs the type-specific content (file id, link, modal html)
  return inject(ResourceApiService).getResource(Number(route.paramMap.get('id')), ['content', 'tags']);
};
